import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect x=\"2.5\" y=\"4\" width=\"19\" height=\"19\" rx=\"4.29268\" class=\"primary\"></rect><path d=\"M12 1C10.3431 1 9 2.34315 9 4H15C15 2.34315 13.6569 1 12 1Z\" class=\"primary\"></path><circle cx=\"12.0425\" cy=\"3.93902\" r=\"0.939024\" class=\"contrast\"></circle><rect x=\"9.125\" y=\"9.75\" width=\"8.5\" height=\"1.5\" rx=\"0.75\" class=\"contrast\"></rect><rect x=\"9.125\" y=\"12.75\" width=\"8.5\" height=\"1.5\" rx=\"0.75\" class=\"contrast\"></rect><rect x=\"9.125\" y=\"15.75\" width=\"5.875\" height=\"1.5\" rx=\"0.75\" class=\"contrast\"></rect><circle cx=\"7.25\" cy=\"10.5\" r=\"0.875\" class=\"faded\"></circle><circle cx=\"7.25\" cy=\"13.5\" r=\"0.875\" class=\"faded\"></circle><circle cx=\"7.25\" cy=\"16.5\" r=\"0.875\" class=\"faded\"></circle>", 9)
  ])))
}
export default { render: render }